import React from 'react';

import Header from './components/headerComponent';
import Sidebar from './components/sidebarComponent';

import WorkExperience from './components/workExperienceComponet';
import Education from './components/educationComponent';
import Interests from './components/interestsComponent';
import Links from './components/linksComponent';

const homePageComponent = props => {
  return (
      <div className="row">
        <aside className="col l4 m12 s12 sidebar z-depth-1" id="sidebar">
          <div className="row">
            <Header/>
            <Sidebar/>
          </div>
        </aside>
        <section className="col s12 m12 l8 section">
          <div className="row">
            <WorkExperience/>
            <Education/>
            <Interests/>
            <Links/>
          </div>
        </section>
      </div>
  )
};

export default homePageComponent;